import { render, staticRenderFns } from "./customizationWaitingRoom.vue?vue&type=template&id=646a1593"
import script from "./customizationWaitingRoom.vue?vue&type=script&lang=js"
export * from "./customizationWaitingRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports